import { notification } from "antd";

type NotificationType = "success" | "error" | "warning" | "info";

const getSingleText = (msg?: string, desc?: string) => {
  const text = desc ?? msg;
  return (
    <span className="whitespace-nowrap text-[14px] font-normal text-slate-700">
      {text}
    </span>
  );
};

const commonConfig = {
  placement: "topRight" as const,
  style: { width: "max-content" },
};

export const notify = {
  success(message?: string, description?: string) {
    notification.success({
      message: getSingleText(message, description) as any,
      ...commonConfig,
    });
  },
  warning(message?: string, description?: string) {
    notification.warning({
      message: getSingleText(message, description) as any,
      ...commonConfig,
    });
  },
  info(message?: string, description?: string) {
    notification.info({
      message: getSingleText(message, description) as any,
      ...commonConfig,
    });
  },
  error(message?: string, description?: string) {
    notification.error({
      message: getSingleText(message, description) as any,
      ...commonConfig,
    });
  },
  toast(
    message?: string,
    variant: NotificationType = "info",
    description?: string
  ) {
    notification[variant]({
      message: getSingleText(message, description) as any,
      ...commonConfig,
    });
  },
};
